import React from 'react'
import './App.css'
import Header from './components/layouts/header'
import Footer from './components/layouts/footer'
import GolfCourseDetail from './pages/golf-course-detail'
import About from './pages/about'
import GolfCourse from './pages/golf-course'
import News from './pages/news'
import NewsDetail from './pages/news-detail'
import TournamentDetail from './pages/tournament-detail'
import Explore from "./pages/explore"
import ExploreDetail from './pages/explore-detail'
import Tournament from './pages/tournament'
import GolfClub from './pages/golf-club'
import PreTournament from './pages/pre-tournament'
import GolfClubWeb from './pages/golf-clup-web'
import Handicap from './pages/handicap'
import {
    BrowserView,
    isMobile,
    isChrome,
    isSafari,
} from 'react-device-detect'
import ScoreHistoryDetail from './pages/score-history-detail'
import {
    BrowserRouter as Router,
    HashRouter,
    Switch,
    Route,
} from 'react-router-dom'
import MomentUtils from '@date-io/moment'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import queryString from 'query-string'

function App() {
    const search = queryString.parse(window.location.search)
    const lang = localStorage.getItem('i18nextLng')

    if (typeof search.language != 'undefined') {
        const language = ['th', 'en'].includes(search.language) ? search.language : 'th'

        localStorage.setItem('i18nextLng', language)

        window.location.href = window.location.origin + window.location.pathname
    } else if (!lang || lang === 'en-US') {
        localStorage.setItem('i18nextLng', 'th')
    }

    return (
        <div className="App">
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {isMobile ?
                    <div>{isChrome || isSafari ?
                        <Router>
                            <Header/>
                            <Switch>
                                <Route path="/explore/:id/:lang" component={ExploreDetail}/>
                                <Route path="/scoreHistory/:memberID/:id/:lang" component={ScoreHistoryDetail}/>
                                <Route path="/golf-course-detail/:id/:lang" component={GolfCourseDetail}/>
                                <Route exact path="/" component={Explore}/>
                                <Route path="/about" component={About}/>
                                <Route path="/golf-course" component={GolfCourse}/>
                                <Route path="/golf-club-web/:id/:lang" component={GolfClubWeb}/>
                                <Route path="/tournament/:id/:lang" component={Tournament}/>
                                <Route path="/news" component={News}/>
                                <Route path="/news-detail/:id/:lang" component={NewsDetail}/>
                                <Route path="/pre-tournament" component={PreTournament}/>
                                <Route path="/tournament-detail/:id/:lang/:type/:base" component={TournamentDetail}/>
                            </Switch>
                            <Footer/>
                        </Router> :
                        <HashRouter>
                            <Switch>
                                <Route path="/golf-club/:id/:lang" component={GolfClub}/>
                                <Route path="/golfCourse/:id/:lang" component={GolfCourseDetail}/>
                                <Route path="/tournament/:id/:lang" component={Tournament}/>
                                <Route path="/news/:id/:lang" component={NewsDetail}/>
                                <Route path="/exploreHandicap/:id/:lang" component={ExploreDetail}/>
                                <Route path="/scoreHistory/:memberID/:id/:lang" component={ScoreHistoryDetail}/>
                                <Route path="/handicapHistory/:id/:lang" component={Handicap}/>
                                <Route path="/tournament-detail/:id/:lang/:type/:base" component={TournamentDetail}/>
                            </Switch>
                        </HashRouter>
                    }
                    </div>
                    :
                    <BrowserView>
                        <Router>
                            <Switch>
                                <Route exact path="/embed/explore/:lang" render={(props) => (
                                    <Explore {...props} isEmbed={true}/>
                                )}/>
                                <Route exact path="/embed/explore/:id/:lang" component={ExploreDetail}/>

                                <Route path="/" render={() => {
                                    return (
                                        <React.Fragment>
                                            <Header/>
                                            <Switch>
                                                <Route path="/explore/:id/:lang" component={ExploreDetail}/>
                                                <Route path="/scoreHistory/:memberID/:id/:lang" component={ScoreHistoryDetail}/>
                                                <Route path="/golf-course-detail/:id/:lang" component={GolfCourseDetail}/>
                                                <Route exact path="/" component={Explore}/>
                                                <Route path="/about" component={About}/>
                                                <Route path="/golf-course" component={GolfCourse}/>
                                                <Route path="/golf-club-web/:id/:lang" component={GolfClubWeb}/>
                                                <Route path="/tournament/:id/:lang" component={Tournament}/>
                                                <Route path="/news" component={News}/>
                                                <Route path="/news-detail/:id/:lang" component={NewsDetail}/>
                                                <Route path="/pre-tournament" component={PreTournament}/>
                                                <Route path="/tournament-detail/:id/:lang/:type/:base" component={TournamentDetail}/>
                                            </Switch>
                                            <Footer/>
                                        </React.Fragment>
                                    )
                                }}/>
                            </Switch>
                        </Router>
                    </BrowserView>
                }
            </MuiPickersUtilsProvider>
        </div>
    );
}

export default (App);
